export function PickemsBettingSkeleton() {
  return (
    <div className="mb-8">
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-[1fr_23rem] lg:gap-5">
        <div className="animate-pulse rounded-lg bg-dark-gray px-4 py-6">
          <div className="mb-4 h-8 w-48 rounded-lg bg-gray-700/90" />
          <div className="space-y-4">
            <div className="h-40 w-full rounded-lg bg-gray-700/90" />
            <div className="h-40 w-full rounded-lg bg-gray-700/90" />
            <div className="h-40 w-full rounded-lg bg-gray-700/90" />
          </div>
        </div>
        <div className="flex animate-pulse flex-col rounded-lg bg-card-bg px-5 py-8">
          <div className="mb-6 flex space-x-4">
            <div className="h-20 flex-1 rounded-lg bg-gray-700/90" />
            <div className="h-20 flex-1 rounded-lg bg-gray-700/90" />
          </div>
          <div className="h-full w-full rounded-lg rounded-tr-lg bg-gray-700/90 p-4" />
        </div>
      </div>
    </div>
  );
}
